import { Injectable, OnInit } from '@angular/core';
import { Observable, defer } from 'rxjs';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { ModalService } from '../modal/modal.service';

@Injectable({
  providedIn: 'root',
})
export class CookiesService {
  public static COOKIES_STORAGE_KEY: string = 'allowCookies';

  private _consentGranted: boolean;

  constructor(
    private readonly modalService: ModalService,
    private readonly localStorageService: LocalStorageService
  ) {
    this._consentGranted = this.hasPermissions;
  }

  public get hasPermissions(): boolean {
    return (
      !!this.localStorageService.getItem(CookiesService.COOKIES_STORAGE_KEY)
    );
  }

  public get consentGranted$(): Observable<boolean> {
    return defer(
      () =>
        new Observable<boolean>((observer) => {
          if (this.hasPermissions) {
            observer.next(this._consentGranted);
            observer.complete();
          } else {
            this.modalService.openAllowCookiesModal().subscribe((consent: boolean) => {
              this._consentGranted = consent;
              observer.next(consent);
            });
          }
        })
    );
  }
}
